'use client';

import dynamic from 'next/dynamic';

import { usePathname } from '@/i18n/routing';
import { pathNeedsAppProviders } from '@/lib/performance/app-providers-scope';

const AppDataProviders = dynamic(
  () => import('./AppDataProviders').then(mod => ({ default: mod.AppDataProviders })),
  { ssr: true },
);

export function Providers({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  if (!pathNeedsAppProviders(pathname)) {
    return children;
  }

  return <AppDataProviders>{children}</AppDataProviders>;
}
